var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm8":"","md4":"","lg4":""}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }